import Vue from 'vue'
import Router from 'vue-router'
import {
    BASEURL
} from '@/utils/common/config'
import login from '@/view/login/login'

// 获取权限，阻止跨角色
import {
    post
} from "@/utils/api/router";
const url = BASEURL + 'admin/menu/index'
var auth = []

post(url, '').then(res => {
    // console.log(res.data);
    for (let i = 0; i < res.data.length; i++) {
        auth.push(res.data[i].router_path)
        if (res.data[i].children) {
            for (let k = 0; k < res.data[i].children.length; k++) {
                auth.push(res.data[i].children[k].router_path)
            }
        }

    }
    auth.push('/404')
    auth.push('/')
    // console.log(auth);
})



Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
    // mode: 'history',
    routes: [{
        // 404 没有的路由全部跳转404
        path: '*',
        name: 'error',
        component: () =>
            import('@/view/404/404.vue'),
    },
    {
        // 404 没有的路由全部跳转404
        path: '/404',
        name: '404',
        component: () =>
            import('@/view/404/404.vue'),
    },
    {
        path: '/',
        name: 'login',
        component: login
    },
    {
        // 首页
        path: '/home',
        name: 'home',
        component: () =>
            import('@/view/home/home.vue'),
        meta: {
            requireAuth: true,
            ue: true
        },
        redirect: '/home/index',
        children: [{
            path: 'index',
            name: 'index',
            component: () =>
                import('@/view/index/index.vue'),
        },
        {
            path: 'MicroStoreChange',
            name: 'MicroStoreChange',
            component: () =>
                import('@/view/index/MicroStoreChange.vue'),
        },
        {
            // 设置模块
            path: 'set_mods',
            name: 'set_mods',
            component: () =>
                import('@/view/set/set_mods/set_mods.vue'),
        },
        {
            // 用户管理
            path: 'set_user',
            name: 'set_user',
            component: () =>
                import('@/view/set/set_user/set_user.vue'),
        },
        {
            // 角色管理
            path: 'set_admin',
            name: 'set_admin',
            component: () =>
                import('@/view/set/set_admin/set_admin.vue'),
        },
        {
            // 主题
            path: 'theme',
            name: 'theme',
            component: () =>
                import('@/view/System-settings/theme/theme.vue')
        },
        {
            // ip登录日志
            path: 'journal',
            name: 'journal',
            component: () =>
                import('@/view/System-settings/journal/journal.vue')
        },
        {
            // ip登录日志
            path: 'help',
            name: 'help',
            component: () =>
                import('@/view/System-settings/help/help.vue')
        },
        {
            // 关于我们 about
            path: 'about',
            name: 'about',
            component: () =>
                import('@/view/about/about.vue')
        }, {
            // 公告列表 notice
            path: 'notice',
            name: 'notice',
            component: () =>
                import('@/view/System-settings/notice/notice.vue')
        },
        // 系统配置-----》》end
        //  ---------------------------------------------------


        // 页面配置 start---------------
        // ============================================
        {
            // 订单列表
            path: 'order',
            name: 'order',
            component: () =>
                import('@/view/order/order.vue')
        },
        {
            // 订单列表--退款
            path: 'order_refund',
            name: 'order_refund',
            component: () =>
                import('@/view/order_refund/order_refund.vue')
        },
        {
            //理法课程订单
            path: 'order_canon',
            name: 'order_canon',
            component: () =>
                import('@/view/order/order_canon.vue')
        },
        {
            // 商品列表
            path: 'goods',
            name: 'goods',
            component: () =>
                import('@/view/integral-mall/goods/goods.vue')
        }, {
            // 商品列表
            path: 'goods_category',
            name: 'goods_category',
            component: () =>
                import('@/view/integral-mall/goods_category/index.vue')
        }, {
            // 会员列表
            path: 'member_type',
            name: 'member_type',
            component: () =>
                import('@/view/member_type/member_type.vue')
        }, {
            // 会员类型
            path: 'type',
            name: 'type',
            component: () =>
                import('@/view/type/type.vue')
        }, {
            // 会员类型
            path: 'body_category',
            name: 'body_category',
            component: () =>
                import('@/view/body_category/body_category.vue')
        },
        {
            // 配置设置
            path: 'setting',
            name: 'setting',
            component: () =>
                import('@/view/setting/setting.vue')
        }, {
            //动态
            path: 'dynamic',
            name: 'dynamic',
            component: () =>
                import('@/view/dynamic/dynamic.vue')
        },
        {
            path: 'article',
            name: 'article',
            component: () =>
                import('@/view/article/article.vue')
        },
        {

            path: 'category',
            name: 'category',
            component: () =>
                import('@/view/category/category.vue')
        },
        {
            // 用户管理
            path: 'user',
            name: 'user',
            component: () =>
                import('@/view/user/user.vue')
        },
        {
            // 广告管理 advertisement
            path: 'advertisement',
            name: 'advertisement',
            component: () =>
                import('@/view/advertisement/advertisement.vue')
        },

        {
            // 课程订单
            path: 'lesson_order',
            name: 'lesson_order',
            component: () =>
                import('@/view/lesson_order/lesson_order.vue')
        }, {
            //会员订单
            path: 'member_order',
            name: 'member_order',
            component: () =>
                import('@/view/member_order/member_order.vue')
        },
        {
            // 分享配置
            path: 'share',
            name: 'share',
            component: () =>
                import('@/view/share/share.vue')
        },

        {
            // 点位课程
            path: 'vedio_lesson',
            name: 'vedio_lesson',
            component: () =>
                import('@/view/vedio_lesson/vedio_lesson.vue')
        }, {
            // 点位课程
            path: 'vedio_canon',
            name: 'vedio_canon',
            component: () =>
                import('@/view/vedio_canon/vedio_canon.vue')
        },
        {
            // 公益课程
            path: 'public_good_lesson',
            name: 'public_good_lesson',
            component: () =>
                import('@/view/vedio_lesson/public_good_lesson.vue')
        },
        {
            // 视力课程
            path: 'vision_lesson',
            name: 'vision_lesson',
            component: () =>
                import('@/view/vedio_lesson/vision_lesson.vue')
        },
        {
            //收费课程
            path: 'charge_lesson',
            name: 'charge_lesson',
            component: () =>
                import('@/view/vedio_lesson/charge_lesson.vue')
        },
        // ------->>>>
        {
            // 测富文本 edit 
            path: 'edit',
            name: 'edit',
            component: () =>
                import('@/components/edit/test.vue')
        },

        {
            //预约时间
            path: 'goods_time',
            name: 'goods_time',
            component: () =>
                import('@/view/integral-mall/goods_time/goods_time.vue')
        },
        {
            //预约时间--历史
            path: 'goods_time_history',
            name: 'goods_time_history',
            component: () =>
                import('@/view/integral-mall/goods_time/goods_time_history.vue')
        }, {

            path: 'integral_log',
            name: 'integral_log',
            component: () =>
                import('@/view/integral_log/index.vue')
        }, {
            //小白分类
            path: 'category_basics',
            name: 'category_basics',
            component: () =>
                import('@/view/category_basics/index.vue')
        }, {
            //小白分类
            path: 'category_basic_order',
            name: 'category_basic_order',
            component: () =>
                import('@/view/order/category_basic_order.vue')
        }, {
            //小白分类
            path: 'grade',
            name: 'grade',
            component: () =>
                import('@/view/grade/index.vue')
        },
        {
            //商家申请列表
            path: 'business',
            name: 'business',
            component: () =>
                import('@/view/business/apply/index.vue')
        },
        {
            //商家服务分类
            path: 'serviceCate',
            name: 'serviceCate',
            component: () =>
                import('@/view/business/serviceCate/index.vue')
        },
        {
            //商家服务项目
            path: 'serviceItems',
            name: 'serviceItems',
            component: () =>
                import('@/view/business/serviceItems/index.vue')
        },
        {
            //商家服务项目
            path: 'healthClass',
            name: 'healthClass',
            component: () =>
                import('@/view/business/healthClass/index.vue')
        },

        ]
    }
    ]
})

router.afterEach((to, from, next) => {
    // // 重置body滚动条
    // document.querySelector('body').style.overflowY = 'auto';
    // // 防止页面回跳
    // if (from.path == '/about/') {

    // } else {
    // 	window.scrollTo(0, 0);
    // }

})

router.beforeEach((to, from, next) => {
    // 自动登录
    if (to.path == '/') {
        if (window.localStorage.token) {
            next({
                path: '/home'
            })
        }
    }

    if (auth.length != 0) {
        if (auth.indexOf(to.path) == -1) {
            next({
                path: '/404'
            })
        }
    }

    // if (to.query.token) {
    // 	window.localStorage.token = to.query.token
    // }
    // if (to.meta.requireAuth) {
    // 	//是否是需要权限的页面
    // 	if (token != '') {
    // 		next()
    // 	} else {
    // 		next({
    // 			path: '/'
    // 		})
    // 	}
    // } else {
    // 	//不需要权限的页面
    // 	next()
    // }
    next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js